import {Box, Text} from "@mantine/core";
import {Dropzone, DropzoneProps} from "@mantine/dropzone";
import {IconUpload, IconX} from "@tabler/icons-react";
import {forwardRef} from "react";
import classes from "./FileSelector.module.css"
import cx from "clsx";
import {IRawFile, TRawFileId} from "../types";
import {IFileUploadStatus} from "@/protocols/types/protocol.ts";
import {FileDisplayComponent} from "./FileDisplayComponent";


interface FileSelectorProps extends DropzoneProps {
    disabledText?: string
    files?: Array<IRawFile>
    uploads?: Record<TRawFileId, IFileUploadStatus>
    onDelete: (file: IRawFile) => void
}


export const FileSelector = forwardRef<HTMLDivElement, FileSelectorProps>(({
                                                                               disabled,
                                                                               disabledText,
                                                                               uploads,
                                                                               files,
                                                                               onDelete,
                                                                               ...others
                                                                           }, ref) => {
        const renderFileDisplay = () => {

            if ((!files || files.length === 0) && (!uploads || Object.keys(uploads || {}).length === 0)) {
                return <FileDisplayComponent onDelete={() => null}/>
            } else {
                const fileComponents = files ? files.map((file) => (
                        <FileDisplayComponent key={file.id} file={file} onDelete={onDelete}/>
                    )
                ) : []
                const progressComponents = uploads ?
                    Object.keys(uploads).map((key) => (
                            <FileDisplayComponent
                                key={`${uploads[key].file.id}-uploading`}
                                file={uploads[key]}
                                onDelete={onDelete}/>
                        )
                    ) : []
                return (
                    <Box className={classes.files}>
                        <Box className={classes.fileHeader}>
                            <Text ta="center" fw={"bold"}>Actions</Text>
                            <Text ta="center" fw={"bold"}>File</Text>
                            <Text ta="center" fw={"bold"}>Size</Text>
                        </Box>
                        <Box className={classes.fileContent}>
                            {[...fileComponents, progressComponents,
                                <Text ta="center" size="xl" inline> Drop File here, or click to select. </Text>]}
                        </Box>
                    </Box>
                )
            }
        }
        return (<Dropzone {...others} ref={ref}
                          disabled={disabled} className={cx(disabled && classes.disabled)}>
                <Box className={cx(classes.container)}>
                    <Dropzone.Accept>
                        <Box style={{
                            display: "grid",
                            grid: "auto / min-content auto",
                            alignItems: "center",
                            justifyItems: "start"
                        }}>
                            <IconUpload size={52} color="white" stroke={1.5}/>
                            <Text ta="center"> Drop the files here..</Text>
                        </Box>
                    </Dropzone.Accept>
                    <Dropzone.Reject>
                        <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5}/>
                    </Dropzone.Reject>
                    <Dropzone.Idle>
                        {disabled ? <Box>{disabledText || ""}</Box> : renderFileDisplay()}
                    </Dropzone.Idle>

                </Box>
            </Dropzone>
        )
    }
)